<template>
  <div class="select-game" id="select-game">
    <div class="game-box-container">
      <div
        v-for="(boxItem, bindex) in gameLists"
        class="game-box"
        :key="bindex"
        v-show="(hideSomeGames && bindex < 2) || !hideSomeGames"
      >
        <div
          class="game-logo j-select-game"
          v-for="(item, index) in boxItem"
          :key="index"
          :data-gameid="item.ID"
          v-on:click="selectGame(item)"
          :class="[item.empty ? 'not-select' : false]"
        >
          <template v-if="!item.empty">
            <img
              class="img"
              :class="platformClass"
              :src="item.PIC_URL || defaultIcon"
            />
            <p class="name" :class="platformClass">{{ item.NAME }}</p>
            <div class="go-btn">GO</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { EventBus } from '../../utiles/eventbus.js';
import {
  UPDATE_GAMEID,
  UPDATE_THIRD_LIST,
  UPDATE_GAME_LOGIN_TYPE,
  DEFAULT_ICON,
  SWITCH_LANGUAGE
} from '../../store/web/login';
import { deviceDirectionPortrait } from '../../utiles/device';

import { LOAD_SERVICE_STATUS } from '../../store/services';
import globalConfig from '../../utiles/globalConfig';
export default {
  name: 'selectGamePage',
  data() {
    return {
      preCount: 4,
      defaultIcon: DEFAULT_ICON
    };
  },
  props: ['hideSomeGames', 'platformClass'],
  mounted() {
    this.preCount = deviceDirectionPortrait() ? 3 : 4;
    if (window.onorientationchange) {
      window.addEventListener(
        'orientationchange',
        () => {
          this.preCount = deviceDirectionPortrait() ? 3 : 4;
        },
        false
      );
    } else {
      window.addEventListener(
        'resize',
        () => {
          this.preCount = deviceDirectionPortrait() ? 3 : 4;
        },
        false
      );
    }
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    },
    gameLists() {
      let res = [];
      let resI = 0;
      let i = this.preCount;
      /* eslint-disable no-unused-vars */
      for (let key in this.$store.state.gameList) {
        if (i === this.preCount) {
          res.push([this.$store.state.gameList[key]]);
          i--;
        } else {
          res[resI].push(this.$store.state.gameList[key]);
          i--;
          if (i === 0) {
            resI += 1;
            i = this.preCount;
          }
        }
      }
      // 空元素补位
      if (res.length) {
        let lastLength = res[res.length - 1].length;
        if (lastLength < this.preCount) {
          let fixArr = new Array(this.preCount - lastLength).fill({
            empty: true
          });
          res[res.length - 1] = res[res.length - 1].concat(fixArr);
        }
      }
      if (res.length === 1 && res[0].length === 1) {
        this.selectGame(res[0][0].ID);
      }
      return res;
    }
  },
  methods: {
    selectGame(item) {
      if (item.empty) {
        return;
      }
      let gameid = item.ID;
      this.$store.dispatch(LOAD_SERVICE_STATUS, gameid);
      this.$store
        .dispatch(UPDATE_GAMEID, gameid)
        .then(this.$store.dispatch(UPDATE_GAME_LOGIN_TYPE))
        .then(this.$store.dispatch(UPDATE_THIRD_LIST));
      EventBus.$emit('updateLogo', gameid);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/webLogin-v3.scss';
.select-game {
  overflow: hidden;
}

.game-box {
  // overflow: hidden;
  display: flex;
  width: 100%;
  justify-content: flex-start;
  gap: 0.5vh;
}
.game-logo {
  float: left;
  // margin-left: 0.8vh;
  // margin-right: 0.8vh;
  padding-top: 0.92vh;
  box-sizing: border-box;
  margin-bottom: 2.3vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: auto;
  font-size: 1.6vh;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  &.not-select {
    cursor: none;
    user-select: none;
    pointer-events: none;
  }
  $w: 24vw;
  $mw: 14vh;
  .img {
    width: $w;
    height: $w;
    border-radius: 20%;
    margin-bottom: 0.4vh;
    border: 1px solid $grey;
    transition: all 0.2s;
    overflow: hidden;
    max-width: $mw;
    max-height: $mw;
  }

  .img[src=''],
  img:not([src]) {
    opacity: 0;
  }
  .name {
    text-align: center;
    // margin: auto;
    margin: 0;
    // color: $font;
    transition: all 0.2s;
    font-family: 'SourceHanSansCN-Bold';
    text-overflow: clip;
    white-space: normal;
    width: $w;
    max-width: $mw;
    font-size: 1.6vh;
    -webkit-text-size-adjust: none;
  }
  .go-btn {
    display: none;
  }
  &:hover {
    cursor: pointer;
    position: relative;
    z-index: 1001;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 9px;
      box-shadow: 0px 0px 15px 0px #e1e1e1;
      z-index: -1;
      background: #fff;
      width: 100%;
      height: calc(100% + 5vh);
    }

    .go-btn {
      display: block;
      border-radius: 2vh;
      background: #1d7bfb;
      color: #fff;
      font-size: 2vh;
      position: absolute;
      padding: 0.6vh 1.85vh;
      // margin: 1.48vh 0 2vh;
      bottom: -4vh;
    }
  }
}

.game-logo.cur {
  .img {
    border: 1px solid $green;
  }
  .name {
    color: $green;
  }
}
</style>
